import {
  Component,
  input,
  output,
  viewChild,
  TemplateRef
} from '@angular/core';

import { ProfileEditFormComponent, ProfileSubStep } from '@sondermind/features/account-edit';
import { IrisButtonContainerAlignments, IrisButtonTypes } from '@sondermind/iris/button';

@Component({
  selector: 'client-setup-basic-info',
  templateUrl: './setup-basic-info.component.html',
  styleUrls: ['./setup-basic-info.component.scss'],
  standalone: false
})
export class SetupBasicInfoComponent {
  readonly useInSessionRequest = input<boolean>(false);
  readonly isMobile = input<boolean>(false);
  readonly isProposeATime = input<boolean>(false);
  readonly fromDirectBooking = input<boolean>(false);

  readonly basicInfoSubmitted = output<void>();

  readonly profileEditForm = viewChild.required<ProfileEditFormComponent>('profileEditForm');

  // Template for the action button that parent component can render
  readonly actionButtonTemplate = viewChild.required<TemplateRef<unknown>>('actionButton');

  readonly irisButtonContainerAlignments = IrisButtonContainerAlignments;
  readonly irisButtonTypes = IrisButtonTypes;

  /**
   * Advance the account-info form. When it is split into sub-steps (direct booking), the first click
   * moves to the next sub-step; on the final sub-step it submits, which triggers attestation signing.
   */
  submitBasicInfo(): void {
    if (this.profileEditForm().goToNextSubStep()) {
      this.profileEditForm().submitForm();
    }
  }

  /**
   * Return to the previous account-info sub-step without losing entered data.
   */
  goBack(): void {
    this.profileEditForm().goToPreviousSubStep();
  }

  get showBackButton(): boolean {
    const form = this.profileEditForm();
    return !!form?.showSubSteps && form.subStep === ProfileSubStep.Contact;
  }

  /**
   * After basic info successfully submits,
   * emit the event to let parent know basic info step is done.
   */
  profileInfoSubmitted(): void {
    this.basicInfoSubmitted.emit();
  }

  /**
   * After attestations successfully submit, let parent know basic info step is done.
   */
  attestationsSubmitted(): void {
    this.basicInfoSubmitted.emit();
  }

  /**
   * Only block Next while a submit is in flight. When the form is invalid we keep the button
   * enabled so the click can reveal Iris's inline validation errors (see submitBasicInfo →
   * profileEditForm.submitForm), rather than silently disabling with no explanation.
   */
  get isSubmitting(): boolean {
    return !!this.profileEditForm()?.submitting;
  }
}
